import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import api from "../../../services/api";

export default function CortesOperador() {
    const [data, setData] = useState([]);

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());

    const [isLoading, setIsLoading] = useState(true);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    // const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get('cortes').then(response => {
            setData(response.data);
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
            showError(error);
        });
    }, []);

    const handleSearch = () => {
        let data_inicial = initialDate.getFullYear() + '-' + String(initialDate.getMonth() + 1).padStart(2, '0') + '-' + String(initialDate.getDate()).padStart(2, '0');
        let data_final = finalDate.getFullYear() + '-' + String(finalDate.getMonth() + 1).padStart(2, '0') + '-' + String(finalDate.getDate()).padStart(2, '0');
        
        api.get('cortes', {
            params: { data_inicial, data_final }
        }).then(response => {
            setData(response.data);
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
            showError(error);
        });
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        let interval = setInterval(() => {
            fetchData();
        }, 1000 * 90);

        return () => {
            clearInterval(interval);
        }
    }, [fetchData]);

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            {isLoading ? 
                <Loading /> 
            : (
                <Card
                    title="Cortes"
                >
                    <div className="p-d-flex p-flex-row p-jc-between p-mb-2">
                        <div>
                            <Calendar 
                                className="p-mr-1"
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                onChange={e => setInitialDate(e.value)}
                                placeholder="Data Inicial"
                                value={initialDate}
                            />

                            <Calendar 
                                className="p-mr-1"
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                onChange={e => setFinalDate(e.value)}
                                placeholder="Data Final"
                                value={finalDate}
                            />

                            <Button 
                                className="p-mr-1"
                                icon="pi pi-search"
                                onClick={handleSearch}
                            />
                        </div>
                        <Button 
                            className="p-button-success"
                            icon="pi pi-refresh"
                            onClick={fetchData}
                        />
                    </div>

                    <DataTable
                        emptyMessage="Nenhum registro encontrado"
                        responsiveLayout="scroll"
                        size="small"
                        tableStyle={{ fontSize: 20 }}
                        value={data}
                    >
                        <Column header="Tear" field="tear" sortable />
                        <Column header="Artigo" field="artigo" sortable />
                        <Column header="Rolada" field="rolada" sortable />
                        <Column header="Rolo" field="rolo" sortable />
                        <Column header="Metros" field="metros_tecido" sortable />
                        <Column header="Data Corte" field="data_cortef" sortable />
                    </DataTable>
                </Card>
            )}
        </div>
    )
}